export const CHECKIN_ACTIONS_SECTION_SOURCE = 'checkin-page'
